import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
 
import LOG, { log } from "../../../UTIL/LOG";
import Cue from "../../../UTIL/Instances/Cue";
import CueProgression from "../../../UTIL/Instances/CueProgression";
import ARRAY from "../../../UTIL/ARRAY";
import GameInstance from "../GameInstance";
import DATE from "../../../UTIL/DATE";
import TimerInstance from "../../../UTIL/Instances/TimerInstance";
import QuestItem from  "./QuestItem";
 
class Quest
{
    public conquer              : CONQUER;
 
    private key                 : string = "$Quest";
    public state                : any;
    private gameInstance        : GameInstance;

    public items                : any = [];
    private Timer               : any | TimerInstance;

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;

        let self            = this;

        this.Timer          = new TimerInstance({ id:"QuestTimer", Signal:this.gameInstance.Signal, onTimeUp:function(){ self.reset() } });
    }

    public get()
    {
        let state = this.state = this.gameInstance.Data.data[ this.key ] || {};
 
        if( !state.startTime ) return this.reset();

        //log("GOT QUEST" );
 
        // items

        let keys            = [ "Loot_Common", "Energy20", "Loot_Rare", "Coin3K", "Loot_Epic", "Coin5K", "Loot_Legendary" ];

        this.items          = [];
 
        for( let n=0; n<7; n++ )
        {
            let vars    = { gameInstance:this.gameInstance, key: keys[n], unlocksAt:n * 3 };

            this.items.push( 
            {
                id          : n+1,
                unlocksAt   : vars.unlocksAt,
                Free        : new QuestItem( vars, false ),
                Premium     : new QuestItem( vars, true )
            });
        }
 
        this.Timer.start({ duration : state.endTime-state.startTime });

        this.save();
  
    }

    public increase()
    {
        this.state.progression ++;
 
        this.save();
    }

    private refresh()
    {
        let collectable : number = 0;

        let current : number = 0;

        for( let n:number=0; n< this.items.length; n++ )
        {
            let tier : any = this.items[n];

            tier.isLocked   = tier.unlocksAt > this.state.progression;
            if( !tier.isLocked ) current = n;

            delete tier.isCurrent;

            collectable += tier.Free.refresh();
            collectable += tier.Premium.refresh();
        }

        this.items[ current ].isCurrent = true;
 
        this.gameInstance.Data.display( "QuestCollectable", collectable );
        this.gameInstance.Signal.set( "Quest:onRefresh", true );
    }
 
    public save()
    {
        this.refresh();
        
        this.gameInstance.Data.set( this.key, this.state );

        this.gameInstance.Signal.set( "Quest:onRefresh", true );
    }

    public reset() : any
    {
        //log("RESET QUEST" );

        let startTime : number = DATE.now();

        this.state = this.gameInstance.Data.data[ this.key ] = 
        {
            startTime      : startTime,
            endTime        : startTime + 604800000, // 7 days
            progression    : 0 
        };
 
        return this.get();
    }

 
}

export default Quest;